module.exports = __webpack_public_path__ + "posture/static/img/knee_overstretch_left.ebed546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/knee_overstretch_left.png
// module id = +64+
// module chunks = 1